import { Box, Divider, Stack, tabsClasses } from '@mui/material';
import { type ReactNode } from 'react';

import { colors } from '../../theme';
import { isDefined } from '../../utils/types.js';
import { NotableBreadcrumb, type NotableBreadcrumbProps } from '../Breadcrumb/Breadcrumb.js';
import { STANDARD_LAYOUT_PADDING_X } from '../Layout/constants.js';

export interface ActionBarProps {
  breadcrumbProps: NotableBreadcrumbProps;
  /**
   * Use Tag component here
   */
  tags?: ReactNode;
  /**
   * For more actions, use ButtonAndMenu component
   */
  actions?: ReactNode;
  tabBar?: ReactNode;
}

export function ActionBar(props: ActionBarProps) {
  const { breadcrumbProps, actions, tags, tabBar } = props;

  return (
    <Stack gap={isDefined(tabBar) ? 0 : 1}>
      <Stack gap={1}>
        <Stack
          display="flex"
          justifyContent="space-between"
          direction="row"
          alignItems="center"
          // Fixed height prevents the action bar from growing and ensures alignment with the navigation bar's top section
          height="40px"
          overflow="hidden"
          gap={1}
          paddingX={STANDARD_LAYOUT_PADDING_X}
        >
          <Stack direction="row" gap={1} alignItems="center" overflow="hidden">
            <Box overflow="hidden">
              <NotableBreadcrumb {...breadcrumbProps} />
            </Box>
            {tags}
          </Stack>
          <Stack direction="row" gap={1} alignItems="center" flexShrink={0}>
            {actions}
          </Stack>
        </Stack>
        {isDefined(tabBar) && (
          <Box sx={{ [`& .${tabsClasses.root}`]: { borderBottom: 'none' } }}>
            <Box paddingX={STANDARD_LAYOUT_PADDING_X}>{tabBar}</Box>
          </Box>
        )}
      </Stack>
      <Divider sx={{ borderColor: colors.border.light }} />
    </Stack>
  );
}
